'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable sort-keys, max-len */
exports.default = {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: 'Войдите для участия в аукционе',
                signup: 'Зарегистрируйтесь для участия в аукционе',
                register_short: 'Зарегистрируйтесь',
                register_long: 'Зарегистрируйтесь на аукцион',
                pending: 'Регистрация в процессе',
                declined: 'Регистрация отклонена',
                closed: 'Лот закрыт',
                sent: 'Ваша ставка отправлена',
                outbid: 'Вашу сумму перебили, предложенная ставка {amount} долларов США',
                bid: 'Ставка {amount} долларов США',
                winning: 'Вы лидируете'
            },
            conversions: {
                lot_number: 'Лот {lotNumber}'
            },
            description: {
                estimate_range: 'Оценка {low} - {high} долларов США',
                images_label: '{currentImageNumber} / {totalImages}'
            },
            messages: {
                competing_bid_amount: '{amount} долларов США: Конкурирующая ставка',
                competing_bidder_outbid_by_liveauctioneers_absentee: 'Ваша ставка была перебита участником {paddleNumber} по заочной ставке',
                last_bid_retracted: 'Последняя ставка в размере {amount} долларов США была отменена',
                liveauctioneers_bid_amount: '{amount} долларов США: Очный участник {paddleNumber}',
                liveauctioneers_bid_amount_absentee: '{amount} долларов США: Заочный бид участника {paddleNumber}',
                lot_number_passed: 'Лот {lotNumber} завершен',
                lot_number_reopened: 'Лот {lotNumber} открыт снова',
                lot_number_skipped: 'Лот {lotNumber} пропущен',
                lot_number_unsold: 'Лот {lotNumber} не продан',
                lot_opened_asking: 'Лот {lotNumber} открыт - Запрашивается {amount} долларов США',
                lot_sold_competing_bidder: 'Лот {lotNumber} продан конкурирующему участнику за {amount} долларов США',
                lot_sold_liveauctioneers_bidder: 'Лот {lotNumber} продан участнику {paddleNumber} за {amount} долларов США',
                my_bid_amount: '{amount} долларов США: Мой бид',
                my_bid_amount_absentee: '{amount} долларов США: Мой заочный бид',
                my_bid_retracted: 'Ваша ставка в размере {amount} долларов США была отменена',
                registration_approved: 'Ваша регистрация одобрена',
                reserve_not_met: 'Резерв не достигнут',
                you_been_outbid_by_liveauctioneers_absentee: 'Ваша ставка была перебита участником {paddleNumber} по заочной ставке',
                you_ve_won_lot: 'Вы выиграли лот {lotNumber}'
            },
            missives: {
                fair_warning_lot_about_to_close: 'Предупреждение... Этот лот скоро будет закрыт',
                going_once_going_twice: 'РАЗ... ДВА...',
                third_and_final_warning: 'ТРИ И ПОСЛЕДНЕЕ ПРЕДУПРЕЖДЕНИЕ...'
            },
            status: {
                remaining: '{remaining} из {total} оставшихся лотов'
            },
            thumbnail_scroller: {
                next: 'Следующие лоты'
            }
        }
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/intl/ru.js
// module id = TAw9
// module chunks = 60